import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkMark",
  "use": "icon-checkMark-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-checkMark\"><path d=\"M512 141.21142579a370.78857421 370.78857421 0 1 0 370.78857421 370.78857421A370.78857421 370.78857421 0 0 0 512 141.21142579z m0 692.13843048A321.34985625 321.34985625 0 1 1 833.34985625 512 321.34985625 321.34985625 0 0 1 512 833.34985625z\" p-id=\"4021\" /><path d=\"M686.76525606 372.08886993L459.59497347 599.25915253l-122.36022953-122.11327851A24.71899687 24.71899687 0 1 0 302.13366699 512l139.91113008 139.91113007a24.71899687 24.71899687 0 0 0 34.85412596 0l244.720459-244.72045899a24.71899687 24.71899687 0 1 0-34.85412597-34.85412597z\" p-id=\"4022\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/checkMark.svg
// module id = KR3F
// module chunks = 1